var analityc = { 
    data : [], 
	active : false,
	trackCompleteRegistration: function(params) {
    	fbq('track', 'CompleteRegistration', params);
    },
	trackAddPaymentInfo: function(params) {
    	fbq('track', 'AddPaymentInfo', params);
    },
    trackAddToCart: function(params) {
    	fbq('track', 'AddToCart', params);
    },
    trackAddToWishlist: function(params) {
    	fbq('track', 'AddToWishlist', params);
    },
	trackInitiateCheckout: function(params) {
    	fbq('track', 'InitiateCheckout', params);
    },
	trackLead: function(params) {
    	fbq('track', 'Lead', params);
    },
	trackPurchase: function(params) {
    	fbq('track', 'Purchase', params);
    }
}